import {
    BellAlertIcon,
    CalendarDaysIcon,
    ChartBarIcon,
    ChatBubbleLeftRightIcon,
    ClipboardDocumentCheckIcon,
    ClockIcon,
    ShieldCheckIcon,
    SignalIcon,
    Squares2X2Icon,
    VideoCameraIcon
} from '@heroicons/react/24/outline';
import type { PartIcon } from './types';

export const PART_ICONS: Record<PartIcon, typeof VideoCameraIcon> = {
    'video-camera': VideoCameraIcon,
    'calendar-days': CalendarDaysIcon,
    clock: ClockIcon,
    'clipboard-document-check': ClipboardDocumentCheckIcon,
    'chat-bubble-left-right': ChatBubbleLeftRightIcon,
    'squares-2x2': Squares2X2Icon,
    'shield-check': ShieldCheckIcon,
    signal: SignalIcon,
    'bell-alert': BellAlertIcon,
    'chart-bar': ChartBarIcon
};
